import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import 'hammerjs';
import { MAT_SELECTSEARCH_DEFAULT_OPTIONS, MatSelectSearchOptions, NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ConfirmDialogComponent } from 'src/app/components/shared/confirm-dialog/confirm-dialog.component';
import { PromptDialogComponent } from 'src/app/components/shared/prompt-dialog/prompt-dialog.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MapComponent } from './components/map/map.component';
import { RolesComponent } from './components/users/roles/roles.component';
import { UsersComponent } from './components/users/users/users.component';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AdminComponent } from './components/admin/admin.component';
import { environment } from 'src/environments/environment';
import { TutorialComponent } from './components/tutorial/tutorial.component';

/**
 * Questo è il modulo principale dell'applicazione.
 */
@NgModule({
  declarations: [
    /**
     * Il componente principale dell'applicazione.
     */
    AppComponent,

    /**
     * Il componente per il dashboard dell'applicazione.
     */
    DashboardComponent,

    /**
     * Il componente per la gestione degli utenti.
     */
    UsersComponent,

    /**
     * Il componente per la gestione dei ruoli degli utenti.
     */
    RolesComponent,

    /**
     * Il componente per il dialog di promp.
     */
    PromptDialogComponent,

    /**
     * Il componente per il dialog di conferma.
     */
    ConfirmDialogComponent,

    /**
     * Il componente per la mappa dell'applicazione.
     */
    MapComponent,

    /**
     * Il componente per la barra di navigazione.
     */
    NavbarComponent,
    AdminComponent,
    TutorialComponent,
  ],
  imports: [
    /**
     * Modulo per la gestione del browser.
     */
    BrowserModule,

    /**
     * Modulo comune per funzionalità Angular.
     */
    CommonModule,

    /**
     * Modulo per la gestione del routing dell'applicazione.
     */
    AppRoutingModule,

    /**
     * Modulo per le animazioni.
     */
    BrowserAnimationsModule,

    /**
     * Modulo per la barra degli strumenti.
     */
    MatToolbarModule,

    /**
     * Modulo per il progress spinner.
     */
    MatProgressSpinnerModule,

    /**
     * Modulo per la gestione dei form.
     */
    FormsModule,

    /**
     * Modulo per il layout flessibile.
     */
    FlexLayoutModule,

    /**
     * Modulo per la gestione del sorting delle tabelle.
     */
    MatSortModule,

    /**
     * Modulo per la gestione dei select.
     */
    MatSelectModule,

    /**
     * Modulo per la gestione della ricerca nei select.
     */
    NgxMatSelectSearchModule,

    /**
     * Modulo per la gestione degli input.
     */
    MatInputModule,

    /**
     * Modulo per le chiamate HTTP.
     */
    HttpClientModule,

    /**
     * Modulo per i pulsanti.
     */
    MatButtonModule,

    /**
     * Modulo per i badge.
     */
    MatBadgeModule,

    /**
     * Modulo per il sidenav.
     */
    MatSidenavModule,

    /**
     * Modulo per l'autocompletamento.
     */
    MatAutocompleteModule,

    /**
     * Modulo per la lista.
     */
    MatListModule,

    /**
     * Modulo per la gestione delle tabelle.
     */
    MatTableModule,

    /**
     * Modulo per gli icon.
     */
    MatIconModule,

    /**
     * Modulo per i dialog.
     */
    MatDialogModule,

    /**
     * Modulo per l'espansione dei contenuti.
     */
    MatExpansionModule,

    /**
     * Modulo per le checkbox.
     */
    MatCheckboxModule,

    /**
     * Modulo per le tabs.
     */
    MatTabsModule,

    /**
     * Modulo per il datepicker.
     */
    MatDatepickerModule,

    /**
     * Modulo per la gestione dei form reattivi.
     */
    ReactiveFormsModule,

    /**
     * Modulo per la paginazione delle tabelle.
     */
    MatPaginatorModule,

    /**
     * Modulo per i pulsanti toggle.
     */
    MatButtonToggleModule,

    /**
     * Modulo per le funzionalità delle tabelle.
     */
    CdkTableModule,

    /**
     * Modulo per i tooltip.
     */
    MatTooltipModule,

    /**
     * Modulo per i campi dei form.
     */
    MatFormFieldModule,

    /**
     * Modulo per la gestione delle date con moment.js.
     */
    MatMomentDateModule,

    /**
     * Modulo per le card.
     */
    MatCardModule,

    /**
     * Modulo per i chip.
     */
    MatChipsModule,

    /**
     * Modulo per l'accordion.
     */
    CdkAccordionModule,

    /**
     * Modulo per le notifiche semplici.
     */
    SimpleNotificationsModule.forRoot({
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: true,
    }),
  ],
  /**
   * Opzioni predefinite per la ricerca nei select.
   */
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: () => async () => {
        let res: any;
        try {
          res = await fetch('/geoweb/assets/data/app-config.json') || {};
          if (res.ok) {
            const data = await res.json();
            Object.assign(environment, data);
          }
        }
        catch (e) {
          console.error(e);
        }
      },
      deps: [],
      multi: true
    },
    /**
     * Fornisce il locale delle date come italiano.
     */
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    /**
     * Interceptor per l'autenticazione con token.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    /**
     * Interceptor per la gestione generale delle chiamate HTTP.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    /**
     * Opzioni predefinite per la ricerca nei select.
     */
    {
      provide: MAT_SELECTSEARCH_DEFAULT_OPTIONS,
      useValue: <MatSelectSearchOptions>{
        placeholderLabel: 'Cerca...',
        noEntriesFoundLabel: 'Nessun elemento corrispondente',
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
